
import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Img from "gatsby-image"

export function HandleImages(name){

  const data = useStaticQuery(graphql`
  query {
 

    manLaptop:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/07/photo-1579379424253-5aa0a5e1f110.jpg"}}) {
      edges {
        node {
          source_url
          localFile {
            publicURL
            childImageSharp {
              fluid(maxWidth: 800) {
                 ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }


    manHeadset:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/06/discount-bg.jpg"}}) {
      edges {
        node {
          source_url
          localFile {
            publicURL
            childImageSharp {
              fluid(maxWidth: 800) {
                 ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }


    womanServers:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/07/woman-servers.jpg"}}) {
      edges {
        node {
          source_url
          localFile {
            publicURL
            childImageSharp {
              fluid(maxWidth: 800) {
                 ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }



    womanScreen:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/06/TrainerView_Performance.jpg"}}) {
      edges {
        node {
          source_url
          localFile {
            publicURL
            childImageSharp {
              fluid(maxWidth: 800, quality:90) {
                 ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }

    womanTeacher:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/07/teacher.jpg"}}) {
        edges {
          node {
            source_url
            localFile {
              publicURL
              childImageSharp {
                fluid(maxWidth: 800) {
                   ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }






   darkBG:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2019/03/bgbluedark.jpg"}}) {
      edges {
        node {
          source_url
          localFile {
            publicURL
            childImageSharp {
              fluid(maxWidth: 800) {
                 ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }



    phlogo: file(relativePath: { eq: "phlogo.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }


    arrowS: file(relativePath: { eq: "arrow.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }

    
    bike: file(relativePath: { eq: "bike.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }

    
    bored: file(relativePath: { eq: "bored.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }

    
    bot: file(relativePath: { eq: "bot-10.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }

    
    door: file(relativePath: { eq: "door.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }

    
    hacker: file(relativePath: { eq: "hacker.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }

    
    hourglass: file(relativePath: { eq: "hourglass.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }

    
    map: file(relativePath: { eq: "map.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }

    
    shield: file(relativePath: { eq: "shield.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }

    
    student: file(relativePath: { eq: "student.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }


    image1: file(relativePath: { eq: "woman-laptop-bed.jpg" }) {
      childImageSharp {

        fluid( quality: 90) {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


     image2: file(relativePath: { eq: "EvanJoinstheArmy.png" }) {
       childImageSharp {

         fluid {
            ...GatsbyImageSharpFluid
         }
       }
     }



      manWomanComputer: file(relativePath: { eq: "man-woman-computer.jpg" }) {
        childImageSharp {

          fluid( quality: 100) {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }






     bhayes: file(relativePath: { eq: "bhayes.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cblissard: file(relativePath: { eq: "cblissard.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      ckoroscil: file(relativePath: { eq: "ckoroscil.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      imacleod: file(relativePath: { eq: "imacleod.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      jnipp: file(relativePath: { eq: "jnipp.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      jselfe: file(relativePath: { eq: "jselfe.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      kgossett: file(relativePath: { eq: "kgossett.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mmoniz: file(relativePath: { eq: "mmoniz.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      polivo: file(relativePath: { eq: "polivo.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      rprewitt: file(relativePath: { eq: "rprewitt.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      tkannegieter: file(relativePath: { eq: "tkannegieter.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      wknee: file(relativePath: { eq: "wknee.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }



      manProtect: file(relativePath: { eq: "man-protect.png" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid
          }
        }
      }

      womanImprove: file(relativePath: { eq: "improveWoman.png" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid
          }
        }
      }


      manLearn: file(relativePath: { eq: "man-learn.png" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid
          }
        }
      }





      womanTeach: file(relativePath: { eq: "woman-teach.png" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid
          }
        }
      }
      protectBGBlur: file(relativePath: { eq: "protectBGBlur.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }


      teachBGBlur: file(relativePath: { eq: "lecture.jpg" }) {
        childImageSharp {

          fluid {
             ...GatsbyImageSharpFluid_withWebp
          }
        }
      }



     aresLaptop: file(relativePath: { eq: "Project-Ares.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }




    laptopS: file(relativePath: { eq: "white-laptop.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }

    laptopCentered: file(relativePath: { eq: "white-laptop-centered.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }




   pAScreen1: file(relativePath: { eq: "PAScreen1.jpg" }) {
      childImageSharp {

        fluid( quality: 90) {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    pAScreen2: file(relativePath: { eq: "PAScreen2.jpg" }) {
      childImageSharp {

        fluid( quality: 90) {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    pAScreen3: file(relativePath: { eq: "PAScreen3.jpg" }) {
      childImageSharp {

        fluid( quality: 90) {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    pAScreen4: file(relativePath: { eq: "PAScreen4.jpg" }) {
      childImageSharp {

        fluid( quality: 90) {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    pAScreen5: file(relativePath: { eq: "PAScreen5.jpg" }) {
      childImageSharp {

        fluid( quality: 90) {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    
    pAScreen6: file(relativePath: { eq: "PAScreen6.jpg" }) {
      childImageSharp {

        fluid( quality: 90) {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }



        
    pAScreen7: file(relativePath: { eq: "PAScreen7.jpg" }) {
      childImageSharp {

        fluid( quality: 90) {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    academic: file(relativePath: { eq: "academic.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    enterprise: file(relativePath: { eq: "enterprise.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    hrChairs: file(relativePath: { eq: "hr-chairs.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    hrDoc: file(relativePath: { eq: "hr-doc.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    gov: file(relativePath: { eq: "gov.jpg" }) {
      childImageSharp {
        fluid( quality: 90)  {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }




    govBuilding: file(relativePath: { eq: "gov-building.jpg" }) {
      childImageSharp {

        fluid( quality: 90)  {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }




    womanCouch: file(relativePath: { eq: "quote.jpg" }) {
      childImageSharp {

        fluid(quality:90) {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }



    buildings: file(relativePath: { eq: "buildings.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    vote: file(relativePath: { eq: "vote.jpg" }) {
      childImageSharp {

        fluid {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    
    chart: file(relativePath: { eq: "chart.jpg" }) {
      childImageSharp {

        fluid {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }




    cbLaptop: file(relativePath: { eq: "cb-computer.jpg" }) {
      childImageSharp {

        fluid {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

mhU: file(relativePath: { eq: "mhU.jpg" }) {
      childImageSharp {

        fluid {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    
mhulogo: file(relativePath: { eq: "mhulogo.jpg" }) {
  childImageSharp {

    fluid {
      ...GatsbyImageSharpFluid_withWebp
    }
  }
}


mhU2: file(relativePath: { eq: "mhU2.jpg" }) {
  childImageSharp {

    fluid {
      ...GatsbyImageSharpFluid_withWebp
    }
  }
}

 



    womanBenchServers: file(relativePath: { eq: "woman-bench-servers.jpg" }) {
      childImageSharp {

        fluid( quality: 90) {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }



    laptopIllustration: file(relativePath: { eq: "laptop-illustration.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid
        }
      }
    }

    covid2020: file(relativePath: { eq: "2020.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }




    kidComputer: file(relativePath: { eq: "kid-computer.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    bradleyCam: file(relativePath: { eq: "brad-cam.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    youngPeople: file(relativePath: { eq: "young-people.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


   manCoding: file(relativePath: { eq: "man-coding.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

  gamification: file(relativePath: { eq: "gamification.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    humanResources: file(relativePath: { eq: "human-resources.jpg" }) {
      childImageSharp {

        fluid( quality: 90)  {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    doctorMask: file(relativePath: { eq: "doctor-mask.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    
    aresBG: file(relativePath: { eq: "aresbg.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    circadenceBG: file(relativePath: { eq: "circadencebg.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


   crowd: file(relativePath: { eq: "crowd.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    mapBG: file(relativePath: { eq: "mapbg.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    peopleScreen: file(relativePath: { eq: "people-screen.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

 bubble: file(relativePath: { eq: "bubble.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    spiderBot: file(relativePath: { eq: "spider-bot.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid 
        }
      }
    }

    
    womanSportsCoat: file(relativePath: { eq: "WomanSportscoat.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid 
        }
      }
    }



  document: file(relativePath: { eq: "whitepaper.png" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid  }
      }
    }


    navAres: file(relativePath: { eq: "nav-ares.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

   navCompany: file(relativePath: { eq: "nav-company.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
 
 
    navPartners: file(relativePath: { eq: "nav-partners.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    
    navResources: file(relativePath: { eq: "nav-resources.jpg" }) {
      childImageSharp {

        fluid {
           ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    
  mercyhurst: file(relativePath: { eq: "mercyhurst-logo.png" }) {
    childImageSharp {

      fluid {
         ...GatsbyImageSharpFluid  }
    }
  }


  laptopF: file(relativePath: { eq: "laptop-front.png" }) {
    childImageSharp {

      fluid {
         ...GatsbyImageSharpFluid  }
    }
  }




  aresTrainer: file(relativePath: { eq: "trainer-view.jpg" }) {
    childImageSharp {

      fluid {
         ...GatsbyImageSharpFluid_withWebp
      }
    }
  }


  aresLeaderBoard: file(relativePath: { eq: "leader-board.jpg" }) {
    childImageSharp {

      fluid {
         ...GatsbyImageSharpFluid_withWebp
      }
    }
  }




  phU: file(relativePath: { eq: "phU.jpg" }) {
    childImageSharp {

      fluid {
         ...GatsbyImageSharpFluid_withWebp
      }
    }
  }



    laptop:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/06/white-laptop.png"}}) {
      edges {
        node {
          source_url
              localFile {
                publicURL
                childImageSharp {

                  fluid(maxWidth: 900, quality:90) {
                     ...GatsbyImageSharpFluid
                  }
                }
              }
        }
      }
    }

    phone:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/07/hand-phone.png"}}) {
      edges {
        node {
          source_url
              localFile {
                publicURL
                childImageSharp {

                  fluid(maxWidth: 900) {
                     ...GatsbyImageSharpFluid
                  }
                }
              }
        }
      }
    }


    missions:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/06/Missions.jpg"}}) {
      edges {
        node {
          source_url
              localFile {
                publicURL
                childImageSharp {

                  fluid(maxWidth: 900) {
                     ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
        }
      }
    }

  battleRooms:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/06/BattleRooms.jpg"}}) {
      edges {
        node {
          source_url
              localFile {
                publicURL
                childImageSharp {

                  fluid(maxWidth: 900) {
                     ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
        }
      }
    }

    regexStill:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2019/03/regexstill.jpg"}}) {
      edges {
        node {
          source_url
              localFile {
                publicURL
                childImageSharp {

                  fluid(maxWidth: 900) {
                     ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
        }
      }
    }

  mediaCenter:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/06/mediaCenter.jpg"}}) {
      edges {
        node {
          source_url
              localFile {
                publicURL
                childImageSharp {

                  fluid(maxWidth: 900) {
                     ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
        }
      }
    }

    athena:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/06/athenanew.jpg"}}) {
      edges {
        node {
          source_url
              localFile {
                publicURL
                childImageSharp {

                  fluid(maxWidth: 900) {
                     ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
        }
      }
    }


    workRole:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2019/03/workrolesscreen2.jpg"}}) {
      edges {
        node {
          source_url
              localFile {
                publicURL
                childImageSharp {

                  fluid(maxWidth: 900) {
                     ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
        }
      }
    }


    scoreReports:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2018/11/generic-reports.jpg"}}) {
      edges {
        node {
          source_url
              localFile {
                publicURL
                childImageSharp {

                  fluid(maxWidth: 900) {
                     ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
        }
      }
    }


   globalChat:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/06/chat-1.jpg"}}) {
      edges {
        node {
          source_url
              localFile {
                publicURL
                childImageSharp {

                  fluid(maxWidth: 900) {
                     ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
        }
      }
    }




    xP:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2019/02/badges2.jpg"}}) {
      edges {
        node {
          source_url
              localFile {
                publicURL
                childImageSharp {

                  fluid(maxWidth: 900) {
                     ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
        }
      }
    }







   trainerViewA:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/06/TrainerView_Coaching.jpg"}}) {
      edges {
        node {
          source_url
              localFile {
                publicURL
                childImageSharp {

                  fluid(maxWidth: 900) {
                     ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
        }
      }
    }





   trainerViewB:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/06/TrainerView_Performance.jpg"}}) {
    edges {
      node {
        source_url
            localFile {
              publicURL
              childImageSharp {

                fluid(maxWidth: 900) {
                   ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
      }
    }
  }






  arrow:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2019/03/5-strtategies.jpg"}}) {
    edges {
      node {
        source_url
            localFile {
              publicURL
              childImageSharp {

                fluid(maxWidth: 900) {
                   ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
      }
    }
  }


  fSISketch:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2019/07/Screen-Shot-2019-07-23-at-9.20.31-AM.png"}}) {
    edges {
      node {
        source_url
            localFile {
              publicURL
              childImageSharp {

                fluid(maxWidth: 900) {
                   ...GatsbyImageSharpFluid
                }
              }
            }
      }
    }
  }



  genericDude:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2018/11/generic_man2.jpg"}}) {
    edges {
      node {
        source_url
            localFile {
              publicURL
              childImageSharp {

                fluid(maxWidth: 900) {
                   ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
      }
    }
  }






 aresSplash:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2018/11/ares_splash_no_logo.jpg"}}) {
    edges {
      node {
        source_url
            localFile {
              publicURL
              childImageSharp {

                fluid(maxWidth: 900, quality: 90) {
                   ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
      }
    }
  }



 aresTVDemo:allWordpressWpMedia(filter: {source_url: {eq: "https://staging.circadence.com/wp-content/uploads/2020/04/demonstration.jpg"}}) {
  edges {
    node {
      source_url
          localFile {
            publicURL
            childImageSharp {

              fluid(maxWidth: 900) {
                 ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
    }
  }
}












   },
  `)

  const images = {

  womanImprove: <Img alt="Cyber Professional" fluid={data.womanImprove.childImageSharp.fluid} />,
    phlogo: <Img alt="Bike" fluid={data.phlogo.childImageSharp.fluid} />,

    womanSportsCoat: <Img alt="Bike" fluid={data.womanSportsCoat.childImageSharp.fluid} />,
  
    mhU: <Img alt="Teacher" fluid={data.mhU.childImageSharp.fluid} />,
    mhU2: <Img alt="Teacher" fluid={data.mhU2.childImageSharp.fluid} />,
    mhUlogo: <Img alt="Teacher" fluid={data.mhulogo.childImageSharp.fluid} />,
   arrowS: <Img alt="Arrow" fluid={data.arrowS.childImageSharp.fluid} />,
   bored: <Img alt="bored" fluid={data.bored.childImageSharp.fluid} />,
   bot: <Img alt="Bike" fluid={data.bot.childImageSharp.fluid} />,
   door: <Img alt="Bike" fluid={data.door.childImageSharp.fluid} />,
   hacker: <Img alt="Bike" fluid={data.hacker.childImageSharp.fluid} />,
   hourglass: <Img alt="Bike" fluid={data.hourglass.childImageSharp.fluid} />,
   map: <Img alt="Bike" fluid={data.map.childImageSharp.fluid} />,
   shield: <Img alt="Bike" fluid={data.shield.childImageSharp.fluid} />,
   student: <Img alt="Bike" fluid={data.student.childImageSharp.fluid} />,
   bike: <Img alt="Bike" fluid={data.bike.childImageSharp.fluid} />,


   aresTrainer: <Img alt="Teacher" fluid={data.aresTrainer.childImageSharp.fluid} />,
    aresLeaderBoard: <Img alt="Teacher" fluid={data.aresLeaderBoard.childImageSharp.fluid} />,


  
    womanLaptop: <Img alt="Teacher" fluid={data.image1.childImageSharp.fluid} />,
    evanArmy: <Img alt="Teacher" fluid={data.image2.childImageSharp.fluid} />,
    aresLaptop: <Img alt="Teacher" fluid={data.aresLaptop.childImageSharp.fluid} />,
    manLaptop: <Img alt="Man on laptop" fluid={data.manLaptop.edges[0].node.localFile.childImageSharp.fluid} />,
    manHeadset: <Img alt="Man with headset" fluid={data.manHeadset.edges[0].node.localFile.childImageSharp.fluid} />,
    womanServers: <Img alt="Woman in front of servers" fluid={data.womanServers.edges[0].node.localFile.childImageSharp.fluid} />,
    womanScreen: <Img alt="Woman in front of screens" fluid={data.womanScreen.edges[0].node.localFile.childImageSharp.fluid} />,
    womanTeacher: <Img alt="Teacher" fluid={data.womanTeacher.edges[0].node.localFile.childImageSharp.fluid} />,
   manWomanComputer: <Img alt="Man and woman using computer" fluid={data.manWomanComputer.childImageSharp.fluid} />,
    gamification: <Img alt="Gamification" fluid={data.gamification.childImageSharp.fluid} />,
   darkBG: <Img alt="Dark Project Ares Background" fluid={data.darkBG.edges[0].node.localFile.childImageSharp.fluid} />,
   manProtect: <Img alt="Cyber Professional" fluid={data.manProtect.childImageSharp.fluid} />,
   manLearn: <Img alt="Cyber Professional" fluid={data.manLearn.childImageSharp.fluid} />,
   womanTeach: <Img alt="Cyber Professional" fluid={data.womanTeach.childImageSharp.fluid} />,
   protectBGBlur: <Img alt="Blurred Buildings" fluid={data.protectBGBlur.childImageSharp.fluid} />,
   teachBGBlur: <Img alt="Blurred Buildings" fluid={data.teachBGBlur.childImageSharp.fluid} />,
  laptop: <Img alt="Laptop" fluid={data.laptop.edges[0].node.localFile.childImageSharp.fluid} />,
  document: <Img alt="Document" fluid={data.document.childImageSharp.fluid} />,
  phone: <Img alt="Phone" fluid={data.phone.edges[0].node.localFile.childImageSharp.fluid} />,
  placeholder: <Img alt="placeholder" fluid={data.aresLaptop.childImageSharp.fluid} />,
  laptopS: <Img alt="Laptop running Project Ares" fluid={data.laptopS.childImageSharp.fluid} />,

  laptopCentered: <Img alt="Laptop running Project Ares" fluid={data.laptopCentered.childImageSharp.fluid} />,

  missions: <Img alt="Missions" fluid={data.missions.edges[0].node.localFile.childImageSharp.fluid} />,
  battleRooms: <Img alt="Battlerooms" fluid={data.battleRooms.edges[0].node.localFile.childImageSharp.fluid} />,
  regexStill: <Img alt="Battlerooms" fluid={data.regexStill.edges[0].node.localFile.childImageSharp.fluid} />,
  athena: <Img alt="Athena" fluid={data.athena.edges[0].node.localFile.childImageSharp.fluid} />,
  mediaCenter: <Img alt="Media Center" fluid={data.mediaCenter.edges[0].node.localFile.childImageSharp.fluid} />,
  workRole: <Img alt="Work Role" fluid={data.workRole.edges[0].node.localFile.childImageSharp.fluid} />,
  scoreReports: <Img alt="Score and Reports" fluid={data.scoreReports.edges[0].node.localFile.childImageSharp.fluid} />,
  globalChat:  <Img alt="Media Center" fluid={data.globalChat.edges[0].node.localFile.childImageSharp.fluid} />,

  xP: <Img alt="Global Chat" fluid={data.xP.edges[0].node.localFile.childImageSharp.fluid} />,

  trainerViewA: <Img alt="Trainer View" fluid={data.trainerViewA.edges[0].node.localFile.childImageSharp.fluid} />,


  trainerViewB: <Img alt="Trainer View" fluid={data.trainerViewB.edges[0].node.localFile.childImageSharp.fluid} />,


  pAScreen1: <Img alt="Project Ares Screenshot" fluid={data.pAScreen1.childImageSharp.fluid} />,
  pAScreen2: <Img alt="Project Ares Screenshot" fluid={data.pAScreen2.childImageSharp.fluid} />,
  pAScreen3: <Img alt="Project Ares Screenshot" fluid={data.pAScreen3.childImageSharp.fluid} />,
  pAScreen4: <Img alt="Project Ares Screenshot" fluid={data.pAScreen4.childImageSharp.fluid} />,
  pAScreen5: <Img alt="Project Ares Screenshot" fluid={data.pAScreen5.childImageSharp.fluid} />,
  pAScreen6: <Img alt="Project Ares Screenshot" fluid={data.pAScreen6.childImageSharp.fluid} />,
  pAScreen7: <Img alt="Project Ares Screenshot" fluid={data.pAScreen7.childImageSharp.fluid} />,


  phU: <Img alt="Placeholder University" fluid={data.phU.childImageSharp.fluid} />,

chart: <Img alt="Project Ares Screenshot" fluid={data.chart.childImageSharp.fluid} />,

  bhayes: <Img alt="Project Ares Screenshot" fluid={data.bhayes.childImageSharp.fluid} />,
  cblissard: <Img alt="Project Ares Screenshot" fluid={data.cblissard.childImageSharp.fluid} />,
 ckoroscil: <Img alt="Project Ares Screenshot" fluid={data.ckoroscil.childImageSharp.fluid} />,
 imacleod: <Img alt="Project Ares Screenshot" fluid={data.imacleod.childImageSharp.fluid} />,
 jnipp: <Img alt="Project Ares Screenshot" fluid={data.jnipp.childImageSharp.fluid} />,
jselfe: <Img alt="Project Ares Screenshot" fluid={data.jselfe.childImageSharp.fluid} />,
kgossett: <Img alt="Project Ares Screenshot" fluid={data.kgossett.childImageSharp.fluid} />,
mmoniz: <Img alt="Project Ares Screenshot" fluid={data.mmoniz.childImageSharp.fluid} />,
polivo: <Img alt="Project Ares Screenshot" fluid={data.polivo.childImageSharp.fluid} />,
rprewitt: <Img alt="Project Ares Screenshot" fluid={data.rprewitt.childImageSharp.fluid} />,
tkannegieter: <Img alt="Project Ares Screenshot" fluid={data.tkannegieter.childImageSharp.fluid} />,
wknee: <Img alt="Project Ares Screenshot" fluid={data.wknee.childImageSharp.fluid} />,

/*
navAres: <Img alt="Project Ares Screenshot" fluid={data.navAres.childImageSharp.fluid} />,
navPartners: <Img alt="Project Ares Screenshot" fluid={data.navPartners.childImageSharp.fluid} />,
navResoures: <Img alt="Project Ares Screenshot" fluid={data.navResources.childImageSharp.fluid} />,
navCompany: <Img alt="Project Ares Screenshot" fluid={data.navCompany.childImageSharp.fluid} />,


*/


aresBG: <Img alt="Ares BG" fluid={data.aresBG.childImageSharp.fluid} />,

circadenceBG: <Img alt="Circadence BG" fluid={data.circadenceBG.childImageSharp.fluid} />,



navAres: <Img alt="Project Ares Screenshot" fluid={data.navAres.childImageSharp.fluid} />,
navPartners: <Img alt="Project Ares Screenshot" fluid={data.navPartners.childImageSharp.fluid} />,
navResources: <Img alt="Project Ares Screenshot" fluid={data.navResources.childImageSharp.fluid} />,
navCompany: <Img alt="Project Ares Screenshot" fluid={data.navCompany.childImageSharp.fluid} />,


hrChairs: <Img alt="Project Ares Screenshot" fluid={data.hrChairs.childImageSharp.fluid} />,
hrDoc: <Img alt="Project Ares Screenshot" fluid={data.hrDoc.childImageSharp.fluid} />,



doctorMask: <Img alt="Doctor holding mask" fluid={data.doctorMask.childImageSharp.fluid} />,


  academic: <Img alt="Academy" fluid={data.academic.childImageSharp.fluid} />,
  enterprise: <Img alt="Enterprise" fluid={data.enterprise.childImageSharp.fluid} />,
  gov: <Img alt="Government" fluid={data.gov.childImageSharp.fluid} />,
  govBuilding: <Img alt="Government" fluid={data.govBuilding.childImageSharp.fluid} />,
  covid2020: <Img alt="2020" fluid={data.covid2020.childImageSharp.fluid} />,
  bradleyCam: <Img alt="Bradley Hayes" fluid={data.bradleyCam.childImageSharp.fluid} />,

womanCouch: <Img alt="Woman using Project Ares" fluid={data.womanCouch.childImageSharp.fluid} />,

spiderBot: <Img alt="Woman using Project Ares" fluid={data.spiderBot.childImageSharp.fluid} />,

kidComputer: <Img alt="Kid using computer" fluid={data.kidComputer.childImageSharp.fluid} />,


 youngPeople: <Img alt="Trainer View" fluid={data.youngPeople.childImageSharp.fluid} />,
 arrow: <Img alt="Arrow across a gap" fluid={data.arrow.edges[0].node.localFile.childImageSharp.fluid} />,
buildings: <Img alt="Financial Buildings" fluid={data.buildings.childImageSharp.fluid} />,

vote: <Img alt="Hand holding 'I voted' sticker" fluid={data.vote.childImageSharp.fluid} />,

womanBenchServers: <Img alt="Woman on laptop sitting in front of servers" fluid={data.womanBenchServers.childImageSharp.fluid} />,
fSISketch: <Img alt="Woman on laptop sitting in front of servers" fluid={data.fSISketch.edges[0].node.localFile.childImageSharp.fluid} />,

professionals: <Img alt="Cyber Professionals" fluid={data.aresSplash.edges[0].node.localFile.childImageSharp.fluid} />,

aresSplash: <Img alt="Project Ares Splash" fluid={data.aresSplash.edges[0].node.localFile.childImageSharp.fluid} />,

aresTVDemo: <Img alt="Project Ares Splash" fluid={data.aresTVDemo.edges[0].node.localFile.childImageSharp.fluid} />,
genericMan: <Img alt="Project Ares Splash" fluid={data.genericDude.edges[0].node.localFile.childImageSharp.fluid} />,
manCoding: <Img alt="Man coding" fluid={data.manCoding.childImageSharp.fluid} />,
crowd: <Img alt="crowd" fluid={data.crowd.childImageSharp.fluid} />,
mapBG: <Img alt="crowd" fluid={data.mapBG.childImageSharp.fluid} />,
peopleScreen: <Img alt="crowd" fluid={data.peopleScreen.childImageSharp.fluid} />,
mercyhurst: <Img alt="crowd" fluid={data.mercyhurst.childImageSharp.fluid} />,
laptopF: <Img alt="crowd" fluid={data.laptopF.childImageSharp.fluid} />,

laptopIllustration: <Img alt="Laptop Illustration" fluid={data.laptopIllustration.childImageSharp.fluid} />,
humanResources: <Img alt="Three women sitting" fluid={data.humanResources.childImageSharp.fluid} />,
cbLaptop: <Img alt="Laptop" fluid={data.cbLaptop.childImageSharp.fluid} />, 
bubble: <Img alt="Bubble" fluid={data.bubble.childImageSharp.fluid} />,

  };

 return images[name.name]

};
